module.exports = "/images/vendor/lightgallery.js/dist/youtube-play.png?8921bc9cdd0eaf56ec89be386b2a7f7f";